// extracted by mini-css-extract-plugin
export default {"modeloCotizacion":"ModeloCotizacion_modeloCotizacion__Nlghi","modeloCotizacionButton":"ModeloCotizacion_modeloCotizacionButton__EmiT5"};